import { Card, CardContent } from '@repo/shadcn';

import { LoadingSpinner } from '@/components/loaders';
import { HeaderBreadcrumb } from '@/components/ui';
import { SectionDataTable } from '@/components/ui';
import { DateRangePickerUrlFilter } from '@/components/ui/search-filter';

import { AddOpeningBalanceDialog } from './add-opening-balance-dialog.component';
import { CashBoxSummary } from './cash-box-summary.component';
import { cashBoxColumns } from './cash-box.column';
import { useCashBox } from './cash-box.hook';

export const CashBox = () => {
    const { data, isLoading, isError, error } = useCashBox();

    return (
        <Card className={'space-y-4 p-4'}>
            <div className={'flex flex-wrap items-start justify-between gap-4'}>
                <HeaderBreadcrumb
                    showHomeLink={true}
                    items={[{ label: 'Cash Box' }]}
                />
                <div className={'flex flex-wrap items-center gap-3'}>
                    <AddOpeningBalanceDialog />
                    <DateRangePickerUrlFilter />
                </div>
            </div>

            <div className={'space-y-1'}>
                <h2 className={'text-xl font-medium'}>Cash Box</h2>
                <p className={'text-sm text-muted-foreground'}>
                    Review cash movements and balances for the selected date
                    range.
                </p>
            </div>

            {isLoading ? (
                <div className={'flex min-h-40 items-center justify-center'}>
                    <LoadingSpinner />
                </div>
            ) : isError ? (
                <Card>
                    <CardContent className={'p-4 text-sm text-red-500'}>
                        {error && 'status' in error
                            ? `Failed to load cash box data (${error.status}).`
                            : 'Failed to load cash box data.'}
                    </CardContent>
                </Card>
            ) : (
                <>
                    <CashBoxSummary />

                    <h3 className="text-lg font-bold">History</h3>

                    <SectionDataTable
                        isLoading={isLoading}
                        data={data}
                        columns={cashBoxColumns}
                    />
                </>
            )}
        </Card>
    );
};

CashBox.displayName = 'CashBox';
